




























import { Component, Vue } from "vue-property-decorator";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { inject } from 'inversify-props';
import { IDrugService } from '@/interfaces/Services';
import { DrugIdentifierModel } from '../../models/drug';

interface DrugTableModel {
  name: string;
  gtin?: DrugIdentifierModel;
  wapps?: DrugIdentifierModel;
}

@Component({})
class Drugs extends Vue {
  @inject(DependencyIdentifiers.DrugService)
  private drugService!: IDrugService;
  
  private isLoading = true;
  private items: Array<DrugTableModel> = [];
  private search: string = "";
  private get headers() {
    return [
      {
        text: this.$t('drug.fields.name'),
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: this.$t('drug.fields.wapps'),
        align: "left",
        sortable: true,
        value: "wapps.value"
      },
      {
        text: this.$t('drug.fields.gtin'),
        align: "left",
        sortable: true,
        value: "gtin.value"
      }
    ];
  }

  mounted() {
    this.refresh();
  }

  private async refresh() {
    this.isLoading = true;
    try {
      const [ items, total ] = await this.drugService.getMany(1, 200);
      this.items = items.map((raw): DrugTableModel => ({
        name: raw.name,
        gtin: raw.identifiers.find((id) => id.type == 'gtin'),
        wapps: raw.identifiers.find((id) => id.type == 'wapps')
      }));
    } finally {
      this.isLoading = false;
    }
  }
}

export default Drugs;
